import { getCurrentInstance } from 'vue';

let getParentForm = function (formName = 'acadia-form') {
    let component = null;
    let parent = getCurrentInstance().parent;
    while (parent && !component) {
        if (parent.type.name === formName) {
            component = parent;
        }
        parent = parent.$parent;
    }
    return component ? component.ctx : null;
};

export { getParentForm };
